<h1 class="accent-background-element">Convert XLS to JSON</h1>

<mat-dialog-content>
  @if ((loaded | async) ===true) {
    <form [formGroup]="form">
      <div class="column">
        <h4>Country</h4>
        <div>
          <mat-form-field appearance="outline" color="accent" class="custom-outline no-hint">
            <mat-select formControlName="country" class='accent-border-element  mat-body' placeholder="Country">
              @for (country of CountriesIDs | keyvalue; track country) {
                <mat-option class='accent-hover-element'
                  [value]='country.value'>{{country.value}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="column">
        <h4>Sheet Number</h4>
        <div>
          <input placeholder="Sheet Number" formControlName="sheetNumber" default="1" min="1"
            class="accent-border-element mat-body " type="number">
          </div>
        </div>
        <div class="inner-row">
          <label for="file-upload" class="custom-file-upload accent-background-element">
            Upload XLS/XLSX
          </label>
          <input #fileUploadSimple [accept]="'.xls,.xlsx'" type="file" class="file-input" id="file-upload"
            (change)="uploadFile($event)" />
            <p>{{fileName}}</p>
          </div>
        </form>
      }


      @if ((loaded | async) ===false) {
        <div class="spinner-container">
          <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
        </div>
      }
    </mat-dialog-content>

    @if ((loaded | async) ===true) {
      <mat-dialog-actions>
        <div class="spacer"></div>
        <button mat-raised-button color="accent" (click)="convertToJSON()" [disabled]="isDisabledButton()">Convert</button>
      </mat-dialog-actions>
    }